import React, { useState, useEffect, useContext } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { userData, filterRole, filterStatus } from "./UserData";
import moment from "moment";

import {
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  UncontrolledDropdown,
  Modal,
  ModalBody,
  DropdownItem,
  Form,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Row,
  Col,
  PaginationComponent,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableRow,
  DataTableItem,
  Button,
  RSelect,
  TooltipComponent,
} from "../../../components/Component";
import { useForm } from "react-hook-form";
import { UserContext } from "./UserContext";
import http from "../../../utils/http-common";
import swal from "sweetalert";
import ConfirmModal from "../../../components/partials/user-manage/ConfirmModal";

const Broker = () => {
  const { contextData } = useContext(UserContext);
  const [data, setData] = contextData;

  const [sm, updateSm] = useState(false);
  const [tablesm, updateTableSm] = useState(false);
  const [onSearch, setonSearch] = useState(true);
  const [onSearchText, setSearchText] = useState("");
  const [modal, setModal] = useState({
    edit: false,
    add: false,
  });
  const [editId, setEditedId] = useState();
  const [formData, setFormData] = useState({
    _id: "",
    organization_name: "",
    contact_person_name: "",
    contact_person_email: "",
    contact_person_phone: "",
    contact_person_country: "",
    remarks: "",
    user_type: "broker",
    status: "",
    createdAt: "",
  });
  // actionText, submittedData, errorVal are only written, never read
  // eslint-disable-next-line no-unused-vars
  const [actionText, setActionText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [submittedData, setSubmitData] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [errorVal, setError] = useState("");
  const [brokerList, setBrokerList] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState({
    isOpen: false,
    type: null,
    broker: null,
    onConfirm: null,
  });

  const fetchBrokerList = () => {
    http
      .get("/api/v1/brokers")
      .then((response) => {
        setBrokerList(response.data.data || []);
        setData(response.data.data || []);
      })
      .catch((error) => {
        console.error("Error fetching brokers:", error);
      });
  };

  useEffect(() => {
    let newData;
    newData = userData.map((item) => {
      item.checked = false;
      return item;
    });
    setBrokerList([...newData]);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetchBrokerList();
  }, [setData]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (onSearchText !== "") {
      console.log(data);
      const filteredObject = data.filter((item) => {
        const searchText = onSearchText.toLowerCase();
        return (
          (item.organization_name && item.organization_name.toLowerCase().includes(searchText)) ||
          (item.contact_person_name && item.contact_person_name.toLowerCase().includes(searchText)) ||
          (item.contact_person_email && item.contact_person_email.toLowerCase().includes(searchText)) ||
          (item.contact_person_phone && item.contact_person_phone.toLowerCase().includes(searchText)) ||
          (item.contact_person_country && item.contact_person_country.toLowerCase().includes(searchText)) ||
          (item.country && item.country.toLowerCase().includes(searchText))
        );
      });
      setBrokerList([...filteredObject]);
    } else {
      setBrokerList([...data]);
    }
  }, [onSearchText, data]);

  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  // eslint-disable-next-line no-unused-vars
  const _onActionText = (e) => {
    setActionText(e.value);
  };

  const resetForm = () => {
    setFormData({
      _id: "",
      organization_name: "",
      contact_person_name: "",
      contact_person_email: "",
      contact_person_phone: "",
      contact_person_country: "",
      remarks: "",
      user_type: "broker",
      status: "",
      createdAt: "",
    });
  };

  const onFormCancel = () => {
    setModal({ edit: false, add: false });
    resetForm();
  };

  const confirmDeleteBroker = (item) => {
    const id = item._id || item.id;
    if (!id) return;
    setShowConfirmModal({
      isOpen: true,
      type: "deleteBroker",
      broker: item,
      onConfirm: () => {
        performDeleteBroker(id);
        setShowConfirmModal({ isOpen: false, type: null, broker: null, onConfirm: null });
      },
    });
  };

  const performDeleteBroker = (id) => {
    setLoading(true);
    http
      .delete(`/api/v1/brokers/${id}`)
      .then(() => {
        swal("Success", "Broker deleted successfully", "success");
        fetchBrokerList();
      })
      .catch((error) => {
        console.error("Error deleting broker:", error);
        swal("Error", error.response?.data?.message || "Failed to delete broker", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onFormSubmit = (submitData) => {
    setLoading(true);
    const submittedData = {
      organization_name: submitData.organization_name,
      contact_person_name: submitData.contact_person_name,
      contact_person_email: submitData.contact_person_email,
      contact_person_phone: submitData.contact_person_phone || "",
      contact_person_country: submitData.contact_person_country || "Unknown",
      remarks: submitData.remarks || "",
      user_type: "broker",
      status: submitData.status || formData.status || "pending",
    };
    http
      .post("/api/v1/brokers", submittedData)
      .then((response) => {
        if (response.data.success) {
          setSubmitData(response.data.data);
        setFormData("");
        setLoading(false);
          setData([response.data.data, ...data]);
          resetForm();
          setModal({ edit: false, add: false });
          http.get("/api/v1/brokers")
            .then((res) => {
              setBrokerList(res.data.data);
              setData(res.data.data);
            });
        }
      })
      .catch(function (error) {
        console.error("Error creating broker:", error);
        setTimeout(() => {
          setError(error.response?.data?.error || error.message || "An error occurred");
          setLoading(false);
        }, 2000);
      });
  };

  const onEditSubmit = (submitData) => {
    setLoading(true);
    const submittedData = {
          organization_name: submitData.organization_name,
          contact_person_name: submitData.contact_person_name,
          contact_person_email: submitData.contact_person_email,
      contact_person_phone: submitData.contact_person_phone || "",
      contact_person_country: submitData.contact_person_country || "Unknown",
      remarks: submitData.remarks || "",
      user_type: "broker",
      status: submitData.status || formData.status || "pending",
    };
    console.log(submittedData);
    http
      .put(`/api/v1/brokers/${editId}`, submittedData)
      .then((response) => {
        if (response.data.success) {
          swal("Success", "Broker mis à jour avec succès", "success");
        setModal({ edit: false });
          setLoading(false);
          http.get("/api/v1/brokers")
            .then((res) => {
              setBrokerList(res.data.data);
              setData(res.data.data);
            })
            .catch((error) => {
              console.error("Error refreshing brokers:", error);
            });
        }
      })
      .catch(function (error) {
        console.error("Error updating broker:", error);
        setTimeout(() => {
          setError(error.response?.data?.error || error.message || "An error occurred");
          setLoading(false);
        }, 2000);
      });
  };

  const onEditClick = (id) => {
    brokerList.forEach((item) => {
      if (item._id === id) {
        setFormData({
          _id: item._id,
          organization_name: item.organization_name || "",
          contact_person_name: item.contact_person_name || "",
          contact_person_email: item.contact_person_email || "",
          contact_person_phone: item.contact_person_phone || "",
          contact_person_country: item.contact_person_country || "Unknown",
          remarks: item.remarks || "",
          user_type: item.user_type || "broker",
          status: item.status || "pending",
          createdAt: item.createdAt || "",
        });
        setModal({ edit: true, add: false });
        setEditedId(item._id);
      }
    });
  };

  const confirmSuspendBroker = (item) => {
    setShowConfirmModal({
      isOpen: true,
      type: "suspendBroker",
      broker: item,
      onConfirm: () => {
        suspendUser(item.id);
        setShowConfirmModal({ isOpen: false, type: null, broker: null, onConfirm: null });
      },
    });
  };

  const suspendUser = (id) => {
    const newData = [...data];
    const index = newData.findIndex((item) => item.id === id);
    if (index !== -1) {
      newData[index].status = "Suspend";
      setData(newData);
    }
  };

  // Used in DataTableRow (onChange) - eslint false positive
  // eslint-disable-next-line no-unused-vars
  const selectorCheck = (e) => {
    let newData;
    newData = data.map((item) => {
      item.checked = e.currentTarget.checked;
      return item;
    });
    setData([...newData]);
  };

  const toggle = () => setonSearch(!onSearch);

  const { errors, register, handleSubmit } = useForm();

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <React.Fragment>
      <Head title="User List - Compact"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                Broker List
              </BlockTitle>
              <BlockDes className="text-soft">
                <p>You have total {brokerList.length} users.</p>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className={`btn-icon btn-trigger toggle-expand mr-n1 ${sm ? "active" : ""}`}
                  onClick={() => updateSm(!sm)}
                >
                  <Icon name="menu-alt-r"></Icon>
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <DataTable className="card-stretch" scrollable>
            <div className="card-inner position-relative card-tools-toggle">
              <div className="card-title-group">
                <div className="card-tools"></div>
                <div className="card-tools mr-n1">
                  <ul className="btn-toolbar gx-1">
                    <li>
                      <a
                        href="#search"
                        onClick={(ev) => {
                          ev.preventDefault();
                          toggle();
                        }}
                        className="btn btn-icon search-toggle toggle-search"
                      >
                        <Icon name="search"></Icon>
                      </a>
                    </li>
                    <li className="btn-toolbar-sep"></li>
                    <li>
                      <div className="toggle-wrap">
                        <Button
                          className={`btn-icon btn-trigger toggle ${tablesm ? "active" : ""}`}
                          onClick={() => updateTableSm(true)}
                        >
                          <Icon name="menu-right"></Icon>
                        </Button>
                        <div className={`toggle-content ${tablesm ? "content-active" : ""}`}>
                          <ul className="btn-toolbar gx-1">
                            <li className="toggle-close">
                              <Button className="btn-icon btn-trigger toggle" onClick={() => updateTableSm(false)}>
                                <Icon name="arrow-left"></Icon>
                              </Button>
                            </li>
                            <li>
                              <UncontrolledDropdown>
                                <DropdownToggle tag="a" className="btn btn-trigger btn-icon dropdown-toggle">
                                  <div className="dot dot-primary"></div>
                                  <Icon name="filter-alt"></Icon>
                                </DropdownToggle>
                                <DropdownMenu
                                  right
                                  className="filter-wg dropdown-menu-xl"
                                  style={{ overflow: "visible" }}
                                >
                                  <div className="dropdown-head">
                                    <span className="sub-title dropdown-title">Filter Users</span>
                                    <div className="dropdown">
                                      <DropdownItem
                                        href="#more"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                        }}
                                        className="btn btn-sm btn-icon"
                                      >
                                        <Icon name="more-h"></Icon>
                                      </DropdownItem>
                                    </div>
                                  </div>
                                  <div className="dropdown-body dropdown-body-rg">
                                    <Row className="gx-6 gy-3">
                                      <Col size="6">
                                        <div className="custom-control custom-control-sm custom-checkbox">
                                          <input
                                            type="checkbox"
                                            className="custom-control-input form-control"
                                            id="hasBalance"
                                          />
                                          <label className="custom-control-label" htmlFor="hasBalance">
                                            {" "}
                                            Have Balance
                                          </label>
                                        </div>
                                      </Col>
                                      <Col size="6">
                                        <div className="custom-control custom-control-sm custom-checkbox">
                                          <input
                                            type="checkbox"
                                            className="custom-control-input form-control"
                                            id="hasKYC"
                                          />
                                          <label className="custom-control-label" htmlFor="hasKYC">
                                            {" "}
                                            KYC Verified
                                          </label>
                                        </div>
                                      </Col>
                                      <Col size="6">
                                        <FormGroup>
                                          <label className="overline-title overline-title-alt">Age</label>
                                          <RSelect options={filterRole} placeholder="Any Role" />
                                        </FormGroup>
                                      </Col>
                                      <Col size="6">
                                        <FormGroup>
                                          <label className="overline-title overline-title-alt">Status</label>
                                          <RSelect options={filterStatus} placeholder="Any Status" />
                                        </FormGroup>
                                      </Col>
                                      <Col size="12">
                                        <FormGroup className="form-group">
                                          <Button color="secondary">Filter</Button>
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                  </div>
                                  <div className="dropdown-foot between">
                                    <a
                                      href="#reset"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                      }}
                                      className="clickable"
                                    >
                                      Reset Filter
                                    </a>
                                    <a
                                      href="#save"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                      }}
                                    >
                                      Save Filter
                                    </a>
                                  </div>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className={`card-search search-wrap ${!onSearch && "active"}`}>
                <div className="card-body">
                  <div className="search-content">
                    <Button
                      className="search-back btn-icon toggle-search active"
                      onClick={() => {
                        setSearchText("");
                        toggle();
                      }}
                    >
                      <Icon name="arrow-left"></Icon>
                    </Button>
                    <input
                      type="text"
                      className="border-transparent form-focus-none form-control"
                      placeholder="Search by user or email"
                      value={onSearchText}
                      onChange={(e) => onFilterChange(e)}
                    />
                    <Button className="search-submit btn-icon">
                      <Icon name="search"></Icon>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <DataTableBody compact>
              <DataTableHead>
                {/* <DataTableRow className="nk-tb-col-check">
                  <div className="custom-control custom-control-sm custom-checkbox notext">
                    <input
                      type="checkbox"
                      className="custom-control-input form-control"
                      onChange={(e) => selectorCheck(e)}
                      id="uid"
                    />
                    <label className="custom-control-label" htmlFor="uid"></label>
                  </div>
                </DataTableRow> */}

                <DataTableRow size="lg">
                  <span className="sub-text">Organization Name</span>
                </DataTableRow>
                <DataTableRow size="lg">
                  <span className="sub-text">Person Name</span>
                </DataTableRow>
                <DataTableRow size="lg">
                  <span className="sub-text">Person Email</span>
                </DataTableRow>
                <DataTableRow size="lg">
                  <span className="sub-text">Person Phone</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Country</span>
                </DataTableRow>
                <DataTableRow size="lg">
                  <span className="sub-text">Remark</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Status</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Date</span>
                </DataTableRow>

                <DataTableRow className="nk-tb-col-tools text-right"></DataTableRow>
              </DataTableHead>
              {/*Head*/}
              {currentItems.length > 0
                ? currentItems.map((item) => {
                    return (
                      <DataTableItem key={item.id}>
                        <DataTableRow size="lg" dataLabel="Organization Name">
                          <span>{item.organization_name}</span>
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="Person Name">
                          <span>{item.contact_person_name}</span>
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="Person Email">
                          <span>{item.contact_person_email}</span>
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="Person Phone">
                          <span>{item.contact_person_country_code + " " + item.contact_person_phone}</span>
                        </DataTableRow>
                        <DataTableRow size="md" dataLabel="Country">
                          <span>{item.contact_person_country || item.country || "N/A"}</span>
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="Remark">
                          <span>{item.remarks || "N/A"}</span>
                        </DataTableRow>
                        <DataTableRow size="md" dataLabel="Status">
                          <span className={`badge ${item.status === "active" ? "bg-success" : item.status === "pending" ? "bg-warning" : item.status === "inactive" ? "bg-danger" : "bg-secondary"}`}>
                            {item.status || "pending"}
                          </span>
                        </DataTableRow>
                        <DataTableRow size="md" dataLabel="Date">
                          <span>{moment(item.createdAt).format("DD/MM/YY")}</span>
                        </DataTableRow>
                        <DataTableRow className="nk-tb-col-tools" dataLabel="Actions">
                          <ul className="nk-tb-actions gx-1">
                            <li className="nk-tb-action-hidden" onClick={() => onEditClick(item._id)}>
                              <TooltipComponent
                                tag="a"
                                containerClassName="btn btn-trigger btn-icon"
                                id={"edit" + item.id}
                                icon="edit-alt-fill"
                                direction="top"
                                text="Edit"
                              />
                            </li>
                            {item.status !== "Suspend" && (
                              <React.Fragment>
                                <li className="nk-tb-action-hidden" onClick={() => confirmSuspendBroker(item)}>
                                  <TooltipComponent
                                    tag="a"
                                    containerClassName="btn btn-trigger btn-icon"
                                    id={"suspend" + item.id}
                                    icon="user-cross-fill"
                                    direction="top"
                                    text="Suspend"
                                  />
                                </li>
                              </React.Fragment>
                            )}
                            <li className="nk-tb-action-hidden" onClick={() => confirmDeleteBroker(item)}>
                              <TooltipComponent
                                tag="a"
                                containerClassName="btn btn-trigger btn-icon"
                                id={"delete" + item.id}
                                icon="delete"
                                direction="top"
                                text="Delete"
                              />
                            </li>
                            <li>
                              <UncontrolledDropdown>
                                <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger">
                                  <Icon name="more-h"></Icon>
                                </DropdownToggle>
                                <DropdownMenu right>
                                  <ul className="link-list-opt no-bdr">
                                    <li onClick={() => onEditClick(item._id)}>
                                      <DropdownItem
                                        tag="a"
                                        href="#edit"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                        }}
                                      >
                                        <Icon name="edit"></Icon>
                                        <span>Edit</span>
                                      </DropdownItem>
                                    </li>
                                    {item.status !== "Suspend" && (
                                      <React.Fragment>
                                        <li className="divider"></li>
                                        <li onClick={() => confirmSuspendBroker(item)}>
                                          <DropdownItem
                                            tag="a"
                                            href="#suspend"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                            }}
                                          >
                                            <Icon name="na"></Icon>
                                            <span>Suspend User</span>
                                          </DropdownItem>
                                        </li>
                                      </React.Fragment>
                                    )}
                                    <li className="divider"></li>
                                    <li onClick={() => confirmDeleteBroker(item)}>
                                      <DropdownItem
                                        tag="a"
                                        href="#delete"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                        }}
                                      >
                                        <Icon name="delete"></Icon>
                                        <span>Delete</span>
                                      </DropdownItem>
                                    </li>
                                  </ul>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </li>
                          </ul>
                        </DataTableRow>
                      </DataTableItem>
                    );
                  })
                : null}
            </DataTableBody>
            <div className="card-inner">
              {currentItems.length > 0 ? (
                <PaginationComponent
                  itemPerPage={itemPerPage}
                  totalItems={brokerList.length}
                  paginate={paginate}
                  currentPage={currentPage}
                />
              ) : (
                <div className="text-center">
                  <span className="text-silent">No data found</span>
                </div>
              )}
            </div>
          </DataTable>
        </Block>
        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add Broker</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Organization Name *</label>
                      <input
                        className="form-control"
                        type="text"
                        name="organization_name"
                        defaultValue={formData.organization_name}
                        placeholder="Enter organization name"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.organization_name && <span className="invalid">{errors.organization_name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Contact Person Name *</label>
                      <input
                        className="form-control"
                        type="text"
                        name="contact_person_name"
                        defaultValue={formData.contact_person_name}
                        placeholder="Enter contact person name"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.contact_person_name && <span className="invalid">{errors.contact_person_name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Contact Person Email *</label>
                      <input
                        className="form-control"
                        type="email"
                        name="contact_person_email"
                        defaultValue={formData.contact_person_email}
                        placeholder="Enter email"
                        ref={register({
                          required: "This field is required",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address",
                          },
                        })}
                      />
                      {errors.contact_person_email && <span className="invalid">{errors.contact_person_email.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Phone Number</label>
                      <input
                        className="form-control"
                        type="text"
                        name="contact_person_phone"
                        defaultValue={formData.contact_person_phone}
                        placeholder="Enter phone number"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Country</label>
                      <input
                        className="form-control"
                        type="text"
                        name="contact_person_country"
                        defaultValue={formData.contact_person_country}
                        placeholder="Enter country"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        options={[
                          { value: "draft", label: "Draft" },
                          { value: "pending", label: "Pending" },
                          { value: "active", label: "Active" },
                          { value: "inactive", label: "Inactive" },
                        ]}
                        name="status"
                        defaultValue={formData.status ? { value: formData.status, label: formData.status } : { value: "pending", label: "Pending" }}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Remarks</label>
                      <textarea
                        className="form-control"
                        name="remarks"
                        defaultValue={formData.remarks}
                        placeholder="Enter remarks (optional)"
                        rows="3"
                      />
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit" disabled={loading}>
                          {loading ? "Creating..." : "Add Broker"}
                        </Button>
                      </li>
                      <li>
                        <a
                          href="#cancel"
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Update Broker</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <input type="hidden" value={formData._id} name="_id" />
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Organization Name *</label>
                      <input
                        className="form-control"
                        type="text"
                        name="organization_name"
                        defaultValue={formData.organization_name}
                        placeholder="Enter organization name"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.organization_name && <span className="invalid">{errors.organization_name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Contact Person Name *</label>
                      <input
                        className="form-control"
                        type="text"
                        name="contact_person_name"
                        defaultValue={formData.contact_person_name}
                        placeholder="Enter contact person name"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.contact_person_name && <span className="invalid">{errors.contact_person_name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Contact Person Email *</label>
                      <input
                        className="form-control"
                        type="email"
                        name="contact_person_email"
                        defaultValue={formData.contact_person_email}
                        placeholder="Enter email"
                        ref={register({
                          required: "This field is required",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address",
                          },
                        })}
                      />
                      {errors.contact_person_email && <span className="invalid">{errors.contact_person_email.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Phone Number</label>
                      <input
                        className="form-control"
                        type="text"
                        name="contact_person_phone"
                        defaultValue={formData.contact_person_phone}
                        placeholder="Enter phone number"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Country</label>
                      <input
                        className="form-control"
                        type="text"
                        name="contact_person_country"
                        defaultValue={formData.contact_person_country}
                        placeholder="Enter country"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        options={[
                          { value: "draft", label: "Draft" },
                          { value: "pending", label: "Pending" },
                          { value: "active", label: "Active" },
                          { value: "inactive", label: "Inactive" },
                        ]}
                        name="status"
                        defaultValue={formData.status ? { value: formData.status, label: formData.status } : { value: "pending", label: "Pending" }}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Remarks</label>
                      <textarea
                        className="form-control"
                        name="remarks"
                        defaultValue={formData.remarks}
                        placeholder="Enter remarks (optional)"
                        rows="3"
                      />
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit" disabled={loading}>
                          {loading ? "Updating..." : "Update Broker"}
                        </Button>
                      </li>
                      <li>
                        <a
                          href="#cancel"
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <ConfirmModal
          isOpen={showConfirmModal.isOpen}
          onClose={() => setShowConfirmModal({ isOpen: false, type: null, broker: null, onConfirm: null })}
          onConfirm={showConfirmModal.onConfirm || (() => {})}
          title={showConfirmModal.type === "suspendBroker" ? "Suspend broker?" : "Delete broker?"}
          message={
            showConfirmModal.type === "suspendBroker"
              ? (showConfirmModal.broker
                ? `Are you sure you want to suspend "${showConfirmModal.broker.organization_name || "this broker"}"?`
                : "Are you sure you want to suspend this broker?")
              : (showConfirmModal.broker
                ? `Are you sure you want to delete "${showConfirmModal.broker.organization_name || "this broker"}" (${showConfirmModal.broker.contact_person_email || "N/A"})?\n\nThis action cannot be undone.`
                : "Are you sure you want to delete this broker?")
          }
          confirmText={showConfirmModal.type === "suspendBroker" ? "Suspend" : "Delete"}
          cancelText="Cancel"
          type={showConfirmModal.type === "suspendBroker" ? "warning" : "danger"}
          loading={loading}
        />
      </Content>
    </React.Fragment>
  );
};
export default Broker;

